module.exports = __webpack_public_path__ + "static/img/guizhou.7102900.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank/guizhou.jpg
// module id = qD+r
// module chunks = 1